import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { UsersPageComponent } from './components/users-page/users-page.component';
import { UserManagementApiService } from './services/user-management-api/UserManagementApiService';

@NgModule({
  declarations: [
    ProfilePageComponent,
    UsersPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  providers: [
    provideHttpClient(),
    UserManagementApiService,
  ],
  exports: [
    ProfilePageComponent,
    UsersPageComponent,
  ],
})
export class UsersModule { }
